import { styled } from "@mui/material/styles";
import { ButtonProps, Button as ButtonComponent } from "@mui/material";

export const Button = styled(ButtonComponent)<ButtonProps>(({ theme }) => ({
  height: "68px",
  borderRadius: theme.spacing(4),
  fontSize: "20px",
  fontWeight: 700,
  textTransform: "none",
  color: theme.palette.primary.contrastText,
  backgroundColor: theme.palette.secondary.main,
  "&:hover": {
    backgroundColor: theme.palette.primary.contrastText,
    color: theme.palette.secondary.main,
  },
  "&:disabled": {
    backgroundColor: theme.palette.secondary.light,
  },
  width: "100%",
  [theme.breakpoints.down("md")]: {
    height: "48px",
    borderRadius: theme.spacing(2),
    fontSize: "16px",
  },
}));

export const OutlinedButton = styled(Button)<ButtonProps>(({ theme }) => ({
  color: theme.palette.secondary.main,
  borderColor: theme.palette.secondary.main,
  backgroundColor: "transparent",
  borderWidth: "1px",
  "&:hover": {
    color: theme.palette.primary.contrastText,
    backgroundColor: theme.palette.secondary.main,
  },
  "&:disabled": {
    backgroundColor: theme.palette.secondary.light,
  },
  width: "100%",
}));

export const TextButton = styled(OutlinedButton)<ButtonProps>(({ theme }) => ({
  padding: 0,
  border: 0,
  height: "auto",
  width: "auto",
  lineHeight: 1.28,
  "&:hover": {
    backgroundColor: "transparent",
  },
}));
